import {
    add as _add,
    getAll as _getAll,
    getList as _getList,
    update as _update,
    getOneById as _getOneById,
    deleteAll as _deleteAll,
    patchAsync as _patchAsync,
} from "../../api";
import { dateToString } from "utils/dateUtils";

const BASE_URL = "/form-clients";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "stampModificationDatetime",
    orderDirection: "desc",
    pageNumber: 0,
    pageSize: 10,
};

function normalizeFormClientData(data) {
    const { stampCreationDatetime: stampCreationDatetimeInMillis, stampModificationDatetime: stampModificationDatetimeInMillis } = data;

    const stampCreationDatetime = new Date(stampCreationDatetimeInMillis);
    const stampModificationDatetime = new Date(stampModificationDatetimeInMillis);

    return {
        ...data,
        stampCreationDatetime,
        stampModificationDatetime,
        stampCreationDatetimeString: dateToString(stampCreationDatetime),
        stampModificationDatetimeString: dateToString(stampModificationDatetime),
    };
}

function normalizeData(data) {
    return data.map(normalizeFormClientData);
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function getOneById({ id, onSuccess, onError }) {
    _getOneById({
        url: `${BASE_URL}/${id}`,
        onSuccess,
        onError,
        normalizer: normalizeFormClientData,
    });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}

export function setStatusAsync({ id, status }) {
    return _patchAsync({ url: `${BASE_URL}/${id}`, data: { status } });
}

export const preloaders = {
    getClientById: ({ id, onSuccess, onError }) => {
        _getOneById({
            url: `${BASE_URL}/pre-loaders/clients/${id}`,
            onSuccess,
            onError,
        });
    },
};

function normalizeFileCaseData(data) {
    const { startDate: startDateInMillis } = data;
    const startDate = startDateInMillis ? new Date(startDateInMillis) : null;

    return {
        ...data,
        // File case ids are only unique within a module
        fileCaseKey: `${data.module}-${data.fileCaseId}`,
        startDate,
        startDateString: startDate ? dateToString(startDate, false) : "",
    };
}

function normalizeFileCasesData(data) {
    return data.map(normalizeFileCaseData);
}

export const fileCases = {
    getByClientId: ({ clientId, onSuccess, onError }) => {
        _getAll({ url: `${BASE_URL}/file-cases`, data: { clientId }, onSuccess, onError, normalizer: normalizeFileCasesData });
    },
    // Paged search by file number (prefix) or client name
    search: ({ data: { filter = {}, pageNumber = 0, pageSize = 5 }, onSuccess, onInfo, onError }) => {
        _getList({
            url: `${BASE_URL}/file-cases/search`,
            data: { search: filter.search, pageNumber, pageSize },
            onSuccess,
            onInfo,
            onError,
            normalizer: normalizeFileCasesData,
        });
    },
};
